<template>
    <div :class="{'-right-100vw': !isOpen, 'right-0': isOpen}" class="fixed top-0 max-w-340 h-full overflow-y-auto bg-blue-darkest mt-2 transition pt-58" style="z-index: -10">
        <draggable
            forceFallback=true
            v-model="charts"
            scrollSensitivity="190"
            @end="onEnd"
            handle=".handle"
            class="px-30 py-15 overflow-y-auto text-14"
        >
            <li v-for="chart in charts" :key="chart.id" class="handle relative flex items-center mb-4 pl-16 pr-60 py-10 bg-blue-dark cursor-move group">
                <!-- grabber icon -->
                <span><svg xmlns="http://www.w3.org/2000/svg" width="8.432" height="18.432" viewBox="0 0 8.432 18.432" class="fill-blue-lightest group-hover:fill-white"><circle cx="1.5" cy="1.5" r="1.5" transform="translate(0.469 15) rotate(9)"/><circle cx="1.5" cy="1.5" r="1.5" transform="translate(0.469 10) rotate(9)"/><circle cx="1.5" cy="1.5" r="1.5" transform="translate(0.469 5) rotate(9)"/><circle cx="1.5" cy="1.5" r="1.5" transform="translate(0.469 0) rotate(9)"/><circle cx="1.5" cy="1.5" r="1.5" transform="translate(5.469 15) rotate(9)"/><circle cx="1.5" cy="1.5" r="1.5" transform="translate(5.469 10) rotate(9)"/><circle cx="1.5" cy="1.5" r="1.5" transform="translate(5.469 5) rotate(9)"/><circle cx="1.5" cy="1.5" r="1.5" transform="translate(5.469 0) rotate(9)"/></svg></span>
                <span class="ml-16 text-white">{{ chart.title }}</span>
                <svg v-if="canDelete" @click="onDelete(chart)" xmlns="http://www.w3.org/2000/svg" width="12.833" height="14" viewBox="0 0 12.833 14" class="absolute right-0 mr-16 fill-blue-lightest hover:fill-coral">
                    <path id="trash" d="M196.667,139.375v-6.417a.281.281,0,0,0-.292-.292h-.583a.281.281,0,0,0-.292.292v6.417a.281.281,0,0,0,.292.292h.583a.281.281,0,0,0,.292-.292Zm2.333,0v-6.417a.281.281,0,0,0-.292-.292h-.583a.281.281,0,0,0-.292.292v6.417a.281.281,0,0,0,.292.292h.583a.281.281,0,0,0,.292-.292Zm2.333,0v-6.417a.281.281,0,0,0-.292-.292h-.583a.281.281,0,0,0-.292.292v6.417a.281.281,0,0,0,.292.292h.583a.281.281,0,0,0,.292-.292Zm-4.958-9.042h4.083l-.437-1.066a.257.257,0,0,0-.155-.1h-2.889a.257.257,0,0,0-.155.1Zm8.458.292v.583a.281.281,0,0,1-.292.292h-.875v8.641a2.069,2.069,0,0,1-.428,1.308,1.27,1.27,0,0,1-1.03.551h-7.583a1.283,1.283,0,0,1-1.03-.533,1.994,1.994,0,0,1-.428-1.29V131.5h-.875a.281.281,0,0,1-.292-.292v-.583a.281.281,0,0,1,.292-.292h2.816l.638-1.522a1.263,1.263,0,0,1,.492-.574,1.287,1.287,0,0,1,.72-.237h2.917a1.287,1.287,0,0,1,.72.237,1.263,1.263,0,0,1,.492.574l.638,1.522h2.816a.281.281,0,0,1,.292.292Z" transform="translate(-192 -128)" />
                </svg>
            </li>
        </draggable>
    </div>
</template>

<script>
    import { call, get, sync } from 'vuex-pathify'
    import draggable from 'vuedraggable'

    export default {
        props: {
            canDelete: {
                type: Boolean,
                default: false
            },

            canUpdate: {
                type: Boolean,
                default: false
            },

            open: {
                type: Boolean,
                default: false
            },
        },

        components: {
            draggable,
        },

        computed: {
            charts: sync('charts/charts'),
            currentClient: get('auth/client'),

            hasCharts() {
                return this.charts && this.charts.length > 0
            },

            iconClasses() {
                return {
                    'fill-pink': this.isOpen,
                    'fill-white': !this.isOpen && this.hasCharts,
                    'fill-blue-lightest': !this.hasCharts,
                }
            },

            isOpen() {
                return this.open
            },
        },

        methods: {
            destroy: call('charts/destroy'),
            updateOrder: call('clients/updateOrder'),

            onDelete(chart) {
                this.destroy(chart)
            },

            onEnd() {
                let sorted = []

                this.charts = this.charts.map((chart, index) => {
                    sorted.push({chart_id: chart.id, order: index})

                    chart.order = index

                    return chart
                })

                this.updateOrder({client: this.currentClient, sorted: sorted})
            },
        }
    }
</script>
